import { ResponseVM } from "models/responseVM";

const apiUrlBase = process.env.REACT_APP_API_URL_BASE;
const apiUrlController = 'user/';
const apiUrlBaseController = apiUrlBase + apiUrlController;
const apiApiKey = process.env.REACT_APP_API_APIKEY + '';

export async function getById(id) {
    const apiUrlBaseControllerEndpointParameters = apiUrlBaseController + 'getById?id=' + id;
    const model = new ResponseVM();

    try {
        const response = await fetch(apiUrlBaseControllerEndpointParameters, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'XApiKey': apiApiKey
            }
        });

        if( response.status >= 400 && response.status < 600)
        {
            model.success = false;
            model.error = await response.json();
        }
        else
        {
            model.success = true;   
            model.data = await response.json();                     
        }
        
        return model;

    } catch (error: any) {
        model.success = false;
        model.error = error.message;
        return model;
    }
}

export async function getByUserName(userName) {
    const apiUrlBaseControllerEndpointParameters = apiUrlBaseController + 'getByUserName?userName=' + userName;
    const model = new ResponseVM();

    try {
        const response = await fetch(apiUrlBaseControllerEndpointParameters, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'XApiKey': apiApiKey
            }
        });

        if( response.status >= 400 && response.status < 600)
        {
            model.success = false;
            model.error = await response.json();
        }
        else
        {
            model.success = true;   
            model.data = await response.json();                     
        }
        
        return model;

    } catch (error: any) {
        model.success = false;
        model.error = error.message;
        return model;
    }
}

export async function getByFilter(requestVM) {
    const apiUrlBaseControllerEndpoint = apiUrlBaseController + 'getByFilter';
    const model = new ResponseVM();

    try {
        let formData = new FormData();
        formData.append("UserName", requestVM.userName);
        formData.append("CurrentPassword", requestVM.currentPassword);
        formData.append("NewPassword", requestVM.newPassword);
        formData.append("IsSelectedPhoneNumber", requestVM.isSelectedPhoneNumber);
        formData.append("MobilePhone", requestVM.mobilePhone);
        formData.append("Mail", requestVM.mail);

        const response = await fetch(apiUrlBaseControllerEndpoint, {
            method: 'POST',
            headers: {
                'XApiKey': apiApiKey
            },
            body: formData
        });

        if( response.status >= 400 && response.status < 600)
        {
            model.success = false;
            model.error = await response.json();
        }
        else
        {
            model.success = true;   
            model.data = await response.json();                     
        }
        
        return model;
        
    } catch (error: any) {
        model.success = false;
        model.error = error.message;
        return model;
    }
}

export async function getAll() {
    const apiUrlBaseControllerEndpoint = apiUrlBaseController + 'getAll';
    const model = new ResponseVM();

    try {
        const response = await fetch(apiUrlBaseControllerEndpoint, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'XApiKey': apiApiKey
            }
        });

        if( response.status >= 400 && response.status < 600)
        {
            model.success = false;
            model.error = await response.json();
        }
        else
        {
            model.success = true;   
            model.data = await response.json();                     
        }
        
        return model;

    } catch (error: any) {
        model.success = false;
        model.error = error.message;
        return model;
    }
}

export async function recoveryPassword(requestVM) {
    const apiUrlBaseControllerEndpoint = apiUrlBaseController + 'recoveryPassword';
    const model = new ResponseVM();

    try {
        let formData = new FormData();
        formData.append("UserName", requestVM.userName);
        formData.append("CurrentPassword", requestVM.currentPassword);
        formData.append("NewPassword", requestVM.newPassword);
        formData.append("IsSelectedPhoneNumber", requestVM.isSelectedPhoneNumber);
        formData.append("MobilePhone", requestVM.mobilePhone);
        formData.append("Mail", requestVM.mail);

        const response = await fetch(apiUrlBaseControllerEndpoint, {
            method: 'POST',
            headers: {
                'XApiKey': apiApiKey
            },
            body: formData 
        });

        if( response.status >= 400 && response.status < 600)
        {
            model.success = false;
            model.error = await response.json();
        }
        else
        {
            model.success = true;   
            model.data = await response.json();                     
        }
        
        return model;

    } catch (error: any) {
        model.success = false;
        model.error = error.message;
        return model;
    }
}

export async function changePassword(requestVM) {
    const apiUrlBaseControllerEndpoint = apiUrlBaseController + 'changePassword';
    const model = new ResponseVM();

    try {
        let formData = new FormData();
        formData.append("UserName", requestVM.userName);
        formData.append("CurrentPassword", requestVM.currentPassword);
        formData.append("NewPassword", requestVM.newPassword);
        formData.append("IsSelectedPhoneNumber", requestVM.isSelectedPhoneNumber);
        formData.append("MobilePhone", requestVM.mobilePhone);
        formData.append("Mail", requestVM.mail);

        const response = await fetch(apiUrlBaseControllerEndpoint, {
            method: 'POST',
            headers: {
                'XApiKey': apiApiKey
            },
            body: formData
        });

        if( response.status >= 400 && response.status < 600)
        {
            model.success = false;
            model.error = await response.json();
        }
        else
        {
            model.success = true;   
            model.data = await response.json();                     
        }
        
        return model;

    } catch (error: any) {
        model.success = false;
        model.error = error.message;
        return model;
    }
}

export async function changeAlternativeMobilePhoneAndEmail(requestVM) {
    const apiUrlBaseControllerEndpoint = apiUrlBaseController + 'changeAlternativeMobilePhoneAndEmail';
    const model = new ResponseVM();

    try {
        let formData = new FormData();
        formData.append("UserName", requestVM.userName);
        formData.append("CurrentPassword", requestVM.currentPassword);
        formData.append("NewPassword", requestVM.newPassword);
        formData.append("IsSelectedPhoneNumber", requestVM.isSelectedPhoneNumber);
        formData.append("MobilePhone", requestVM.mobilePhone);
        formData.append("Mail", requestVM.mail);

        const response = await fetch(apiUrlBaseControllerEndpoint, {
            method: 'PUT',
            headers: {
                'XApiKey': apiApiKey
            },
            body: formData
        });

        if( response.status >= 400 && response.status < 600)
        {
            model.success = false;
            model.error = await response.json();
        }
        else
        {
            model.success = true;   
            model.data = await response.json();                     
        }
        
        return model;

    } catch (error: any) {
        model.success = false;
        model.error = error.message;
        return model;
    }
}